export default "__VITE_ASSET__cc30bc08__"